/**
 * @ngdoc directives
 * @memberof mercury.directives
 * @name icon-close
 * @description Displays the close icon, this is pulled from the MUI icon we use in React.
 */
angular.module('mercury.directives.icon-close', [])
.directive('iconClose', function() {
    return {
      restrict: 'E',
      template: '<svg class="svg-icon-root" focusable="false" viewBox="0 0 24 24">' +
                  '<path d="M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"></path>' +
                '</svg>',
      scope: {
        extraClasses: '@'
      }
    };
  });